module.exports = __webpack_public_path__ + "files/16696c2f2d33388f884fa00d985f0457.png";